// src/hooks/useGetWaterRequests.js
import { useState, useEffect, useRef, useCallback } from 'react';
import { API_URL } from '../config';
import { authFetch } from '../utils';

function useGetWaterRequests() {
  const [waterRequests, setWaterRequests] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const firstLoad = useRef(true);
  const isMountedRef = useRef(true);

  const fetchWaterRequests = useCallback(() => {
    authFetch(`${API_URL}fwi/water-requests`)
      .then((res) => {
        if (!res.ok) throw new Error('Error al obtener solicitudes de agua');
        return res.json();
      })
      .then((data) => {
        if (!isMountedRef.current) return;
        setWaterRequests(data);
        setError(null);
        setIsLoading(false);
        firstLoad.current = false;
      })
      .catch((err) => {
        if (!isMountedRef.current) return;
        console.error("Error al obtener solicitudes de agua:", err);
        if (firstLoad.current) {
          setError(err);
          setIsLoading(false);
        }
      });
  }, []);

  useEffect(() => {
    isMountedRef.current = true;
    fetchWaterRequests();
    const interval = setInterval(fetchWaterRequests, 10000);
    return () => {
      isMountedRef.current = false;
      clearInterval(interval);
    };
  }, [fetchWaterRequests]);

  return { waterRequests, setWaterRequests, isLoading, error, refresh: fetchWaterRequests };
}

export default useGetWaterRequests;
